/** 访问页面统计详情 table */
import React from 'react';
import {DatePicker, Button, Table, message} from 'antd';
import moment from "moment";
import api from "../../../lib/api";
import PerformanceDetails from "../../../components/PerformanceDetails";

const { RangePicker } = DatePicker;

class ComTable extends React.Component{
  state = {
    scrollY: 600,
    rowData: {},
    showPerformanceDetails: false
  };
  columns = [
    {
      title: '访问时间',
      width: 140,
      dataIndex: 'createTime'
    }, {
      title: '页面加载时间',
      dataIndex: 'loadTime',
      sorter: false,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.loadTime} ms</span>
      )
    }, {
      title: '白屏时间',
      dataIndex: 'firstPaintTime',
      width: 90,
      sorter: false,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.firstPaintTime} ms</span>
      )
    }, {
      title: '资源加载耗时',
      dataIndex: 'requestTime',
      sorter: false,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.requestTime} ms</span>
      )
    }, {
      title: 'DOM解析耗时',
      dataIndex: 'domAnalysisTime',
      sorter: false,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.domAnalysisTime} ms</span>
      )
    }, {
      title: 'DOM构建耗时',
      dataIndex: 'domCompleteTime',
      sorter: false,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.domCompleteTime} ms</span>
      )
    }, {
      title: 'DNS解析耗时',
      dataIndex: 'dnsTime',
      sorter: false,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.dnsTime} ms</span>
      )
    }, {
      title: 'TCP连接耗时',
      dataIndex: 'tcpTime',
      sorter: false,
      showSorterTooltip: false,
      render: (val, row) => (
        <span>{row.tcpTime} ms</span>
      )
    }, {
      title: '浏览器版本',
      width: 150,
      dataIndex: 'browserType',
      render: (val, row) => (
        <span>{row.browserType}{row.browserVersion}</span>
      )
    }, {
      title: '系统',
      width: 70,
      dataIndex: 'systemType',
    }, {
      title: 'IP',
      width: 120,
      dataIndex: 'ip',
    }, {
      title: '详情',
      width: 60,
      fixed: 'right',
      render: (val, row) => (
        <span className="c-primary cursor-no-select" onClick={() => this.getRowData(row)}>查看</span>
      )
    },
  ];
  // 导出
  exportFile = () => {
    const {formFilter, tbFilter} = this.props;
    const params = Object.assign({}, tbFilter, formFilter);
    params.projectId = sessionStorage.getItem('projectId');
    delete params.page;
    delete params.size;
    delete params.statisticsType;
    api.getExportVisitDetail(params).then(res => {
      this.uploadData(res);
    })
  };
  // 下载数据
  uploadData = (res) => {
    if (res.type === 'application/json') {
      message.error("当前没有数据可下载");
      return;
    }
    let xx = "content-disposition";
    let url = window.URL.createObjectURL(new Blob([res["data"]]));
    let link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    let filename = decodeURIComponent(res.headers[xx].split(";")[1].split("=")[1].split('"')[1]);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
  };
  // 获取详情
  getRowData = (row) => {
    api.getVisitInfoDetail(row.id).then(res => {
      if (res.success && res.status === 200) {
        this.setState({
          rowData: res.data || {},
          showPerformanceDetails: true
        });
      } else {
        message.error(res.message);
      }
    })
  };
  // 查看详情 关闭弹窗时清空 rowData， 不然会有缓存问题
  handlePerformanceDetailsCanCel = (boolean) => {
    this.setState({
      showPerformanceDetails: boolean,
      rowData: {}
    })
  };
  UNSAFE_componentWillMount() {
    this.setState({
      scrollY: document.documentElement.clientHeight - 310
    });
    window.onresize= () => {
      this.setState({
        scrollY: document.documentElement.clientHeight - 310
      })
    }
  };
  render() {
    const { loading, pagination, tbData, timeChange } = this.props;
    const { scrollY, rowData, showPerformanceDetails } = this.state;
    const format = 'HH:mm';
    return (
      <div className='card'>
        <div className="mBtm15">
          <RangePicker picker="time" format='HH:mm' defaultValue={[moment('00:00', format), moment('23:59', format)]} onChange={timeChange} allowClear={false} />
          <Button className="down-load" type="primary" onClick={this.exportFile}>导出</Button>
        </div>
        <Table scroll={{x: 1250, y:scrollY }} rowKey='id' bordered loading={loading} pagination={pagination}
          columns={this.columns} dataSource={tbData} onChange={this.props.pageChange} />
        {
          rowData.id ? <PerformanceDetails rowData={rowData} visible={showPerformanceDetails} onCancel={this.handlePerformanceDetailsCanCel} /> : ''
        }
      </div>
    );
  }
};
export default ComTable;
